import React from 'react'
import { observer } from 'mobx-react'

import ConfigStore from 'stores/config/ConfigStore'

import styles from './skeleton.scss'

class Skeleton extends React.PureComponent {
  render() {
    return (
      <div data-cy="skeleton" className={styles.container}>
        <div
          className={styles.tab1}
          style={{ paddingLeft: ConfigStore.headerLeftOffset }}
        />
        <div className={styles.tab2} />
        <div className={styles.tabEmptySpace} />

        <div className={styles.filter1} />
        <div className={styles.filter2} />
        <div className={styles.filter3} />
        <div className={styles.filter4} />

        <div className={styles.separator} />
        <div className={styles.button1} />
        <div className={styles.btnSpace}> Getting things ready...</div>

        <div className={styles.table} />
      </div>
    )
  }
}

export default observer(Skeleton)
